/**
 * Per-line fulfilment from the Heritage order detail.
 *
 * The status endpoint reports these on the order itself, so they exist as soon
 * as Heritage acknowledges — before any shipment record does. Verified against
 * live sandbox orders: an Acknowledged order shows quantityOpen with zero
 * invoiced; a Closed one shows the quantities moved to invoicedQty, while
 * shipment detail may return nothing at either stage.
 */

export interface IOrderLine {
  lineNumber?: number | string | null;
  heritagePartNumber?: string | null;
  itemDescription?: string | null;
  heritageUOM?: string | null;
  quantity?: number | string | null;
  quantityOpen?: number | string | null;
  readyQty?: number | string | null;
  backOrderedQty?: number | string | null;
  invoicedQty?: number | string | null;
  salesPrice?: string | number | null;
  extendedPrice?: string | number | null;
}

/** Lines from the remote-status payload; empty for malformed/absent data. */
export const extractOrderLines = (data: unknown): IOrderLine[] => {
  const lines = (data as { lines?: unknown } | null | undefined)?.lines;
  if (!Array.isArray(lines)) return [];
  return lines.filter(
    (line): line is IOrderLine => line != null && typeof line === "object"
  );
};

/** A count cell: 0 is a real value, null/undefined render as a dash. */
export const formatCount = (
  value: number | string | null | undefined
): string => (value == null || value === "" ? "—" : String(value));
